// extracted by mini-css-extract-plugin
module.exports = {"summaryFilter":"summaryFilter__ryO8a"};